export const getSnackbarSystemData = (state) => {
  return state.VNSnackbarSystem.get('snackbarData')
}
